import { useLayoutEffect, useRef, useState } from 'react'

// Measures a text element's rendered width and returns overflowClassName
// when it exceeds threshold (e.g. to trigger a marquee animation).
// Re-measures whenever `trigger` changes (typically the displayed text
// itself) -- measuring layout requires a post-paint read, there's no
// render-time equivalent.
function useTextOverflowClass(overflowClassName, trigger, threshold = 90) {
  const ref = useRef(null)
  const [width, setWidth] = useState(0)

  useLayoutEffect(() => {
    setWidth(ref.current ? ref.current.offsetWidth : 0)
  }, [trigger])

  return { ref, className: width > threshold ? overflowClassName : false }
}

export default useTextOverflowClass
